import Immutable from 'immutable';
import * as types from './AdminApparelItemParts.types';

const initialState = {
    type: null,
    apparelItemParts: [],
    fetching: false,
    saving: false,
    idModal: null,
    pagination: {
        totalElements: 0,
        activePage: 1,
        totalPages: 0,
        elementsPerPage: 20,
    },
    apparelItem: null,
    apparelItemPart: {
        allow_utp: 0,
        allow_uth: 0,
        allow_manager: 0,
        allow_personal: 0,
        allow_coupa: 0,
    },
    isDeleting: false,
    sort: {
        column: 'name',
        type: 'asc',
    },
    search: '',
    searchType: 'name',
    itemId: null,
    isGenerating: false,
    selectedSizes: [],
    selectedLogos: [],
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.FETCH_APPAREL_ITEM:
            return state.toJS();

        case types.FETCH_APPAREL_ITEM_SUCCESS:
            return state.setIn(['apparelItem'], action.payload).toJS();

        case types.FETCH_APPAREL_ITEM_ERROR:
            return state.toJS();

        case types.FETCH_APPAREL_ITEM_PARTS:
            return state.setIn(['fetching'], true).toJS();

        case types.FETCH_APPAREL_ITEM_PARTS_SUCCESS:
            return state.setIn(['fetching'], false)
                .setIn(['apparelItemParts'], action.payload.elements)
                .setIn(['pagination', 'totalElements'], action.payload.totalElements)
                .setIn(['pagination', 'activePage'], action.payload.activePage)
                .setIn(['pagination', 'totalPages'], action.payload.totalPages)
                .setIn(['pagination', 'elementsPerPage'], action.payload.elementsPerPage)
                .toJS();

        case types.FETCH_APPAREL_ITEM_PARTS_ERROR:
            return state.setIn(['fetching'], false).toJS();

        case types.SAVE_APPAREL_ITEM_PART:
            return state.setIn(['saving'], true).toJS();

        case types.SAVE_APPAREL_ITEM_PART_SUCCESS:
            return state.setIn(['saving'], false)
                .setIn(['idModal'], null)
                .toJS();

        case types.SAVE_APPAREL_ITEM_PART_ERROR:
            return state.setIn(['saving'], false).toJS();

        case types.DELETE_APPAREL_ITEM_PART:
            return state.setIn(['isDeleting'], true).toJS();

        case types.DELETE_APPAREL_ITEM_PART_SUCCESS:
            return state.setIn(['isDeleting'], false)
                .setIn(['idModal'], null)
                .toJS();

        case types.DELETE_APPAREL_ITEM_PART_ERROR:
            return state.setIn(['isDeleting'], false).toJS();

        case types.GENERATE_PARTS:
            return state.setIn(['isGenerating'], true).toJS();

        case types.GENERATE_PARTS_SUCCESS:
            return state.setIn(['isGenerating'], false)
                .setIn(['idModal'], null)
                .toJS();

        case types.GENERATE_PARTS_ERROR:
            return state.setIn(['isGenerating'], false).toJS();

        case types.SET_ID_MODAL:
            return state.setIn(['idModal'], action.payload.sku)
                .setIn(['sizeModal'], action.payload.size)
                .setIn(['logoModal'], action.payload.logo).toJS();

        case types.SET_ACTIVE_PAGE:
            return state.setIn(['pagination', 'activePage'], action.payload).toJS();

        case types.SET_APPAREL_ITEM_PART_FIELD:
            return state.setIn(['apparelItemPart', action.payload.field], action.payload.value).toJS();

        case types.SET_APPAREL_ITEM_PART:
            return state.setIn(['apparelItemPart'], action.payload).toJS();

        case types.RESET_APPAREL_ITEM_PART:
            return state.setIn(['apparelItemPart'], {
                allow_utp: 0,
                allow_uth: 0,
                allow_manager: 0,
                allow_personal: 0,
                allow_coupa: 0,
            }).toJS();

        case types.SET_SORT:
            return state.setIn(['sort', 'type'], action.payload.type)
                .setIn(['sort', 'column'], action.payload.column)
                .toJS();

        case types.SET_SEARCH:
            return state.setIn(['search'], action.payload).toJS();

        case types.SET_SEARCH_TYPE:
            return state.setIn(['searchType'], action.payload).toJS();

        case types.SET_ITEM_ID:
            return state.setIn(['itemId'], action.payload).toJS();

        case types.CHECK_SIZE:
            return state.updateIn(['selectedSizes'], (selectedSizes) => {
                if (action.payload.value) {
                    return selectedSizes.push(action.payload.size);
                } else {
                    const index = selectedSizes.findIndex((size) => size === action.payload.size);
                    return selectedSizes.delete(index);
                }
            }).toJS();

        case types.CHECK_LOGO:
            return state.updateIn(['selectedLogos'], (selectedLogos) => {
                if (action.payload.value) {
                    return selectedLogos.push(action.payload.logo);
                } else {
                    const index = selectedLogos.findIndex((logo) => parseInt(logo) === parseInt(action.payload.logo));
                    return selectedLogos.delete(index);
                }
            }).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}